import { __decorate } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var DictionaryService;
(function (DictionaryService) {
    DictionaryService.SYMBOL = Symbol.for('DictionaryService');
})(DictionaryService || (DictionaryService = {}));
export default (container) => {
    let DictionaryServiceImpl = class DictionaryServiceImpl {
        constructor() {
            Object.defineProperty(this, "cache", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Map()
            });
        }
        createPlaceholder(word) {
            return {
                items: [{
                        entry: word,
                        matchType: 'original',
                        phoneticSigns: [],
                        pos: [{ type: 'word', meanings: [{ meaning: `Original word: ${word}`, examples: [], originalMeaning: word }] }],
                        source: 'original', url: '', mUrl: '', expDicTypeForm: '', locale: 'en', gdid: ''
                    }],
                examples: [],
                isWordType: true,
                originalWord: word
            };
        }
        async getWord(word) {
            if (this.cache.has(word))
                return this.cache.get(word);
            try {
                const res = await fetch(`/datas/english/dictionary/${word}.json`);
                if (!res.ok)
                    throw new Error('not found');
                const dict = await res.json();
                if (dict?.items?.length > 0) {
                    const result = { ...dict, originalWord: word };
                    this.cache.set(word, result);
                    return result;
                }
            }
            catch { }
            const placeholder = this.createPlaceholder(word);
            this.cache.set(word, placeholder);
            return placeholder;
        }
        clearCache() { this.cache.clear(); }
    };
    DictionaryServiceImpl = __decorate([
        Sim({ symbol: DictionaryService.SYMBOL, container: container })
    ], DictionaryServiceImpl);
    return DictionaryServiceImpl;
};
